import io from "socket.io-client";
import { CLIENT_ID } from "../constants/Settings";
import { store } from "../store/useStore";

const _authState = store.auth.state();

const socket = io(`https://${CLIENT_ID}-api.firmli.com`, {
  auth: {
    token: _authState.authToken ?? "",
  },
  extraHeaders: {
    Authorization: _authState.authToken ?? "",
  },
});

export default socket;
